export default {
  remaining: "remaining",
  timerComplete: "Timer complete"
};